module.exports = __webpack_public_path__ + "static/media/blackFriday2021Modal.2d36793c.png";